var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "flex gap-2 items-center text-primary text-xl font-medium",
        },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v(" mdi-note-text-outline "),
          ]),
          _c("span", [_vm._v("การตรวจสลิปโอนเงิน")]),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "py-5 px-7 mt-6 rounded-lg", attrs: { flat: "" } },
        [
          _c(
            "div",
            { staticClass: "flex flex-col sm:flex-row sm:items-center gap-3" },
            [
              _c("span", { staticClass: "text-xl font-medium" }, [
                _vm._v(_vm._s(_vm.$t("order.autoVerifyTitle"))),
              ]),
              _vm.setting.remainingAutoVerifyTrial > 0
                ? _c("span", [
                    _vm._v(
                      " ทดลองฟรีคงเหลือ " +
                        _vm._s(_vm.setting.remainingAutoVerifyTrial) +
                        "/100 ครั้ง "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex flex-col items-start mt-5 gap-3" },
            [
              _c("order-toggle", {
                attrs: {
                  text: _vm.$t("order.autoVerifyPayment"),
                  state: _vm.state.autoVerifyPayment,
                  "text-icon": "$packageTitle",
                },
                on: {
                  input: function ($event) {
                    return _vm.submit("autoVerifyPayment")
                  },
                },
                model: {
                  value: _vm.setting.autoVerifyPayment,
                  callback: function ($$v) {
                    _vm.$set(_vm.setting, "autoVerifyPayment", $$v)
                  },
                  expression: "setting.autoVerifyPayment",
                },
              }),
              _c("packing-toggle", {
                attrs: {
                  text: _vm.$t("order.autoVerifyAcceptOverpaid"),
                  state: _vm.state.autoVerifyAcceptOverpaid,
                  disable: _vm.setting.autoVerifyPayment,
                },
                on: {
                  input: function ($event) {
                    return _vm.submit("autoVerifyAcceptOverpaid")
                  },
                },
                model: {
                  value: _vm.setting.autoVerifyAcceptOverpaid,
                  callback: function ($$v) {
                    _vm.$set(_vm.setting, "autoVerifyAcceptOverpaid", $$v)
                  },
                  expression: "setting.autoVerifyAcceptOverpaid",
                },
              }),
              _c("packing-toggle", {
                attrs: {
                  text: _vm.$t("order.autoVerifyAcceptUnderpaid"),
                  state: _vm.state.autoVerifyAcceptUnderpaid,
                  disable: _vm.setting.autoVerifyPayment,
                },
                on: {
                  input: function ($event) {
                    return _vm.submit("autoVerifyAcceptUnderpaid")
                  },
                },
                model: {
                  value: _vm.setting.autoVerifyAcceptUnderpaid,
                  callback: function ($$v) {
                    _vm.$set(_vm.setting, "autoVerifyAcceptUnderpaid", $$v)
                  },
                  expression: "setting.autoVerifyAcceptUnderpaid",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }